import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/movie', label: '电影' },
    { to: '/category/drama', label: '电视剧' },
    { to: '/category/variety', label: '综艺' },
    { to: '/category/anime', label: '动漫' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-vidicon-line text-2xl ${scrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span
              className={`text-xl font-heading font-bold transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              西瓜视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视内容..."
                className={`w-48 lg:w-56 pl-9 pr-4 py-2 rounded-full text-sm border transition-all duration-200 focus:outline-none focus:w-64 ${
                  scrolled || !isHome
                    ? 'bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400 focus:border-primary-300'
                    : 'bg-background-50/15 border-background-50/20 text-background-50 placeholder-background-50/60 focus:border-background-50/40'
                }`}
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className={`ri-search-line text-sm ${scrolled || !isHome ? 'text-foreground-400' : 'text-background-50/60'}`}></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/40 py-4 bg-background-50/98 backdrop-blur-md">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === link.to
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="mt-3 px-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索影视内容..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-full text-sm border bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
                />
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm text-foreground-400"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}